import cn from 'classnames'
import { Link } from 'react-router-dom'

import { ActionButton } from '../Button'

const RowActionLink = ({ children, className, to, onClick, isDisabled }) => (
  <ActionButton
    className={cn('rowActionItem', className)}
    component={Link}
    to={to}
    onClick={onClick}
    disabled={isDisabled}
  >
    {children}
  </ActionButton>
)

export default RowActionLink
